"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPICY_POPCORN_TIER_SIGMA_MODEL_TYPES = exports.POPCORN_TIER_SIGMA_MODEL_TYPES = void 0;
exports.isPopcornSigmaModelType = isPopcornSigmaModelType;
exports.isSpicyPopcornSigmaModelType = isSpicyPopcornSigmaModelType;
exports.POPCORN_TIER_SIGMA_MODEL_TYPES = new Set([
    'capacitor.polarized',
    'capacitor.nonpolarized',
    'resistor.standard',
    'resistor.variable',
    'resistor.varistor',
    'resistor.thermistor',
    'inductor.standard',
    'ferrite.standard',
    'fuse.generic',
    'fuse.poly',
    'crystal',
]);
exports.SPICY_POPCORN_TIER_SIGMA_MODEL_TYPES = new Set([
    'diode.generic',
    'diode.zener',
    'diode.led',
    'diode.multiled',
    'diode.tvs.bidirectional',
    'diode.tvs.unidirectional',
    'transistor.bjt.npn',
    'transistor.bjt.pnp',
    'mosfet.enhancement.ntype',
    'mosfet.enhancement.ptype',
]);
function isPopcornSigmaModelType(sigmaModelType) {
    return exports.POPCORN_TIER_SIGMA_MODEL_TYPES.has(sigmaModelType);
}
function isSpicyPopcornSigmaModelType(sigmaModelType) {
    return exports.SPICY_POPCORN_TIER_SIGMA_MODEL_TYPES.has(sigmaModelType);
}
//# sourceMappingURL=part-tiers.js.map